import AnnotatedImageChecklist from './AnnotatedImageChecklist';

export default AnnotatedImageChecklist;
